import { render } from "./KarmaBot.vue?vue&type=template&id=e628da22&scoped=true"
import script from "./KarmaBot.vue?vue&type=script&lang=js"
export * from "./KarmaBot.vue?vue&type=script&lang=js"

import "./KarmaBot.vue?vue&type=style&index=0&id=e628da22&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e628da22"]])

export default __exports__